import { useEffect, useState } from 'react';

/** Execute and return a value on the client only to prevent hydration issues */
export function useClient<T>(cb: () => T): T | undefined {
  const [state, setState] = useState<boolean>(false);
  useEffect(() => setState(true), []);
  if (!state) return undefined;
  return cb();
}
